import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionText: {
    fontSize: '14px !important' as any,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important' as any,
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  radioSelection: {
    marginBottom: theme.spacing(1),
  },
  widthRadio: {
    width: 'auto',
    height: theme.spacing(3),
    '& div': {
      width: 'auto !important',

      '& p': {
        width: 'max-content',
      },
    },
  },
  widthButton: {
    width: 'fit-content',
    lineHeight: `${theme.spacing(2.5)}px !important`,
    marginTop: theme.spacing(1),
    fontSize: '14px !important',
    letterSpacing: 0.1,
  },
  minMax: {
    width: theme.spacing(30.25),
  },
  minMaxWrapper: {
    display: 'flex',
    gap: theme.spacing(3),
  },
  plansHeading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  headingWrapper: {
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
  },
  errorMessage: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    margin: theme.spacing(0.5, 1.25, 0, 2),
    color: `${theme.palette.labraV2Errors.main} !important`,
  },
  planSectionHeading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  planSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}))
